<header>
  @if (!isCountrySelectionSite()) {
    <div
      class="header"
      [ngClass]="isCountrySelectionSite() ? 'header-countrySelection' : ''"
    >
      <boels-vertical-aligner
        [innerWidth]="'wide'"
        class="header-top__container"
      >
        <div class="header-top">
          @if (siteContextSlot(); as slot) {
            <section
              class="header-top-left"
              [attr.position]="slot?.position"
              [class]="slot?.position"
              [class.has-components]="slot?.components?.component?.length"
              [boelsSlotDecorator]="slot?.properties"
            >
              @if (slot?.components?.component?.[0]; as context) {
                <boels-contact-us
                  [boelsSlotDecorator]="context?.properties"
                  [contactUsData]="context"
                >
                </boels-contact-us>
              }
            </section>
          }
          @defer {
            @if (!mdAndBelow() && siteLinksSlot(); as slot) {
              <section
                class="header-top-right desktop-view"
                [attr.position]="slot?.position"
                [class]="slot?.position"
                [class.has-components]="slot?.components?.component?.length"
                [boelsSlotDecorator]="slot?.properties"
              >
                @if (!userData()?.loggedIn) {
                  @if (slot?.components?.component?.[0]; as context) {
                    <boels-toggle-user-type
                      [@slideInRight]
                      [boelsSlotDecorator]="context?.properties"
                    >
                    </boels-toggle-user-type>
                  }
                }
                @if (!userData()?.loggedIn || !loginSlot()) {
                  @if (slot?.components?.component?.[1]; as context) {
                    <boels-toggle-language-selector
                      [@slideInRight]
                      [boelsSlotDecorator]="context?.properties"
                    >
                    </boels-toggle-language-selector>
                  }
                }
              </section>
            }
          }
        </div>
      </boels-vertical-aligner>
    </div>
  }
  <boels-vertical-aligner
    [innerWidth]="'wide'"
    class="header-middle__container"
  >
    <div class="header-middle">
      @if (!isCountrySelectionSite()) {
        <fa-icon
          class="header-middle-bars mobile-view"
          [icon]="faBars"
          size="xl"
          (click)="toggleMobileNavigationModule(true)"
        >
        </fa-icon>
      }
      @if (logoSlot(); as slot) {
        <section
          class="header-middle-item"
          [attr.position]="slot?.position"
          [class]="slot?.position"
          [class.has-components]="slot?.components?.component?.length"
          [boelsSlotDecorator]="slot?.properties"
        >
          @if (logoData(); as logoData) {
            <boels-generic-link
              [url]="logoData.urlLink"
              [boelsSlotDecorator]="logoData?.properties"
            >
              <boels-media
                class="header-middle-item-logo"
                [container]="logoData.media"
                [loading]="loadingStrategy"
                [fetchPriority]="fetchPriority"
                [alt]="
                  logoData.imageAltText ||
                  logoData.media?.altText ||
                  'Boels logo'
                "
              >
              </boels-media>
            </boels-generic-link>
          }
        </section>
      }
      <div class="header-middle-item header-middle-item-searchbox">
        @if (searchBoxSlot(); as slot) {
          <section
            class="header-middle-item header-middle-item-searchbox desktop-view"
            [attr.position]="slot?.position"
            [class]="slot?.position"
            [class.has-components]="slot?.components?.component?.length"
            [boelsSlotDecorator]="slot?.properties"
          >
            @if (
              !isHomeSite() &&
                !isCountrySelectionSite() &&
                slot?.components?.component?.[0];
              as context
            ) {
              @if (!mdAndBelow()) {
                <boels-custom-searchbox
                  [boelsSlotDecorator]="context?.properties"
                >
                </boels-custom-searchbox>
              }
            }
          </section>
        }
      </div>
      @defer {
        @if (loginSlot() && !isCountrySelectionSite()) {
          @if (loginSlot(); as slot) {
            <section
              class="header-middle-item header-middle-item-login-indicator"
              [attr.position]="slot?.position"
              [class]="slot?.position"
              [class.has-components]="slot?.components?.component?.length"
              [boelsSlotDecorator]="slot?.properties"
            >
              @if (slot?.components?.component?.[0]; as context) {
                @if (userData(); as userData) {
                  <boels-account
                    [@slideInRight]
                    (logout)="logoutClicked()"
                    (login)="loginClicked()"
                    (openLanguageSelector)="openLanguageSelector()"
                    [boelsUser]="userData.data"
                    [activeCulture]="activeCulture()"
                    [boelsSlotDecorator]="context?.properties"
                  >
                  </boels-account>
                }
              }
            </section>
          }
        }
      }

      @if (miniCartSlot(); as slot) {
        <section
          class="header-middle-item"
          [attr.position]="slot?.position"
          [class]="slot?.position"
          [class.has-components]="slot?.components?.component?.length"
          [boelsSlotDecorator]="slot?.properties"
        >
          @if (slot?.components?.component?.[0]; as context) {
            <boels-generic-link
              [@slideInRight]
              class="header-middle-item-mini-basket"
              [url]="'/cart'"
              [boelsSlotDecorator]="context?.properties"
            >
              <fa-icon
                class="header-middle-item-mini-basket-icon"
                [icon]="faShoppingBasket"
              >
              </fa-icon>
              <span class="header-middle-item-mini-basket-count">{{
                itemsInCart()
              }}</span>
            </boels-generic-link>
          }
        </section>
      }
    </div>
  </boels-vertical-aligner>
  @if (!isHomeSite() && !isCountrySelectionSite()) {
    <boels-vertical-aligner
      [innerWidth]="'wide'"
      class="header-middle-mobile-searchbox mobile-view"
    >
      @if (mdAndBelow()) {
        <boels-custom-searchbox></boels-custom-searchbox>
      }
    </boels-vertical-aligner>
  }
  @if (!isCountrySelectionSite()) {
    @if (navigationBarSlot(); as slot) {
      <section
        class="header-bottom-wrapper"
        [attr.position]="slot?.position"
        [class]="slot?.position"
        [class.has-components]="slot?.components?.component?.length"
        [boelsSlotDecorator]="slot?.properties"
      >
        @if (slot?.components?.component?.[0]; as context) {
          @if (navData(); as navData) {
            @if (mdAndBelow()) {
              <boels-navigation-mobile
                class="mobile-view"
                [navigationData]="navData"
                [isActive]="isMobileModuleActive()"
                [showCountrySelect]="!loginSlot() || !userData()?.loggedIn"
                [showUserType]="!userData()?.loggedIn"
                (closeModuleEvent)="toggleMobileNavigationModule($event)"
                [boelsSlotDecorator]="context?.properties"
              >
              </boels-navigation-mobile>
            }
            @if (!mdAndBelow()) {
              <boels-navigation
                class="desktop-view"
                [nav]="navData"
                [boelsSlotDecorator]="context?.properties"
              >
              </boels-navigation>
            }
          }
        }
      </section>
    }
  }
</header>

@if (placeholderSlot(); as slot) {
  <section
    [attr.position]="slot.position"
    [class.has-components]="slot.components?.component?.length"
    [boelsSlotDecorator]="slot.properties"
  ></section>
}

@if (bottomHeaderSlot(); as slot) {
  @if (breadcrumbData(); as breadcrumbData) {
    <boels-breadcrumb
      [breadcrumbData]="breadcrumbData"
      [whiteBackground]="useWhiteHeader()"
      [boelsSlotDecorator]="slot.properties"
      [class.has-components]="slot.components?.component?.length"
      [attr.position]="slot.position"
    >
    </boels-breadcrumb>
  }
}
